import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { UploadService } from './upload.service';

@Injectable({
  providedIn: 'root'
})
export class ArquivoTermoService {

  constructor(
    private http: HttpClient,
    private uploadService: UploadService) { }

  public consultarArquivosTermo() {
    return this.http.get<any>(globals.apiUrl + '/api/ArquivoTermo/BuscarArquivosTermo');
  }

  public enviarArquivoTermo(tipo, formData) {
    return this.uploadService.upload(formData, globals.apiUrl + '/api/ArquivoTermo/SalvarArquivoTermo?tipo=' + (tipo === 'pedido' ? '0' : '1'));
  }

  public baixarModelo() {
    return this.http.get(globals.apiUrl + '/api/ArquivoTermo/BaixarModelo', { responseType: 'blob' });
  }

  public baixarPorTipo(tipo) {
    return this.http.get(globals.apiUrl + '/api/ArquivoTermo/BaixarArquivoTermo?tipo=' + (tipo === 'pedido' ? '0' : '1'), { responseType: 'blob' });
  }

  public excluirPorTipo(tipo) {
    return this.http.get(globals.apiUrl + '/api/ArquivoTermo/ExcluirArquivoTermo?tipo=' + (tipo === 'pedido' ? '0' : '1'));
  }

}
